import {
  Maybe,
  OfficialInformationConsoleBoxFragment,
} from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  ConsoleOfficialInformationEditFormForm,
  ConsoleOfficialInformationEditFormValues,
} from './ConsoleOfficialInformationEditForm'

export * from './fragments'

export type State = {
  artistId: string
  officialInformation: Maybe<OfficialInformationConsoleBoxFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (values: ConsoleOfficialInformationEditFormValues) => Promise<void>
}

export const ConsoleOfficialInformationEditTemplate: Template<State, Action> =
  ({ state, onSubmit }) => {
    const { t } = useTranslation('consoleOfficialInformationEdit')
    const { routerNames } = useRouter()
    return (
      <ArtistThemeProvider artistId={state.artistId}>
        <Head title={routerNames.ConsoleOfficialInformationEdit} />
        <ConsoleBaseLayout
          margin
          header={{
            back: true,
            title: t('title'),
          }}
        >
          <ConsoleOfficialInformationEditFormForm
            officialInformation={state.officialInformation}
            onSubmit={onSubmit}
          />
        </ConsoleBaseLayout>
      </ArtistThemeProvider>
    )
  }
